export type ApiConfig = {
  apiUrl: string;
  AVMLink: string;
  scenarioExample: string;
  scenarioDemo: string;
};

export type NodeWithChildren = Exclude<
  BaseNode,
  | SliceNode
  | VectorNode
  | StarNode
  | CodeBlockNode
  | ShapeWithTextNode
  | ConnectorNode
  | LineNode
  | EllipseNode
  | PolygonNode
  | RectangleNode
  | MediaNode
  | StickyNode
  | LinkUnfurlNode
  | HighlightNode
  | TableNode
  | WashiTapeNode
  | StampNode
  | WidgetNode
  | EmbedNode
  | TextNode
  | TextPathNode
  | InteractiveSlideElementNode
>;

export type NodeWithReactions = Exclude<
  BaseNode,
  | SliceNode
  | DocumentNode
  | PageNode
  | ComponentSetNode
  | StickyNode
  | ConnectorNode
  | ShapeWithTextNode
  | CodeBlockNode
  | WidgetNode
  | EmbedNode
  | LinkUnfurlNode
  | MediaNode
  | SliceNode
  | SectionNode
  | TableNode
  | SlideNode
  | SlideRowNode
  | SlideGridNode
  | InteractiveSlideElementNode
>;

export type NodeWithSize = Exclude<BaseNode, DocumentNode | PageNode>;

export type HideableNode = Exclude<BaseNode, DocumentNode | PageNode>;

export type OriginalClonePair<T> = {
  original: T;
  clone: T;
};

export type SimpleTextNode = {
  id: string;
  characters: string;
  absolutePosition: {
    x: number;
    y: number;
  };
  width: number;
  height: number;
  size: number;
};

export class OneShotBinary<T extends ArrayBufferView> {
  private value: T | null;

  constructor(value: T) {
    this.value = value;
  }

  take(): T {
    if (!this.value) {
      throw new Error('Binary already consumed');
    }

    const v = this.value;
    this.value = null;

    return v;
  }
}

export type ConvertedImage = {
  converted: OneShotBinary<Uint8Array>;
};

export type ConvertedImageRaw = {
  converted: Uint8Array | null;
};

export type ConvertedImageBase64 = {
  converted: string;
};
